import classNames from 'classnames';
import React from 'react';
import { createPortal } from 'react-dom';
import styles from './Overlay.module.css';

interface Props {
  children: React.ReactNode;
  color?: string;
  className?: string;
}

const modalRoot = document.querySelector('#modal-root');

export const Overlay = ({ children, color, className }: Props) => {
  if (!modalRoot) {
    return null;
  }
  const style = color ? { backgroundColor: color } : {};
  return createPortal(
    <div className={classNames(styles.overlay, className)} style={style}>
      {children}
    </div>,
    modalRoot,
  );
};
